.wrapper {
  padding: 2px;
}
